import { cn } from '@/lib/utils/cn'

/** Indeterminate progress. Respects prefers-reduced-motion via motion.css. */
export function Spinner({
  size = 16,
  className,
  label = 'Loading',
}: {
  size?: number
  className?: string
  label?: string
}) {
  return (
    <span role="status" aria-label={label} className={cn('inline-flex', className)}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
        className="spinner"
      >
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.5" opacity="0.2" />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
    </span>
  )
}
